import React from 'react';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Box,
  IconButton,
  makeStyles
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CardBox from 'components/CardBox'
import Refresh from '@material-ui/icons/Refresh';
import ToolTipIcon from "components/ToolTipIcon";
import MsgPopover from 'components/MsgPopover';
import {SwapHoriz} from '@material-ui/icons';


const useStyles = makeStyles((theme) =>({
    root: {
        fontFamily:'Roboto'
    },
    header : {
        background : theme.palette.secondary.main,
        color:'white'
    },
    newItem : {
        backgroundColor:'rgb(2, 207, 137)',
        padding:'3px 10px',
        fontWeight:500,
        color:'rgb(255, 0, 0)'
    },
    borderLeft: {
      borderLeft: '1px solid #ccc',
    }
}))

const LocationsTable = ({ data, getLocationsList, onEdit }) => {
    const classes = useStyles();

  return (
    <CardBox styleName="col-12" cardStyle="p-0" headerOutside
    heading={
      <React.Fragment>
        <div className="d-flex justify-content-between align-items-center w-100">
          <span>Locations</span>
          <ToolTipIcon
            title="Refresh"
            ariaLabel="refresh"
            icon={<Refresh />}
            onClick={getLocationsList}
          />
        </div>  
        <MsgPopover msg="Big table, scroll horizontally" timeout="1500">
          <Box display={{ xs: 'inline', md: 'none' }}>
            <SwapHoriz color="primary" />
          </Box>
        </MsgPopover>
      </React.Fragment>
    }
  >
    <Box className='p-0'>
      <Table className='p-0'>
        <TableHead>
          {/* First Row - Main Headers */}
          <TableRow>
            <TableCell size="small" classes={{ head:classes.header,root:classes.root }} rowSpan={2}><strong>Name</strong></TableCell>
            <TableCell size="small" classes={{ head:classes.header,root:classes.root }} align="center" rowSpan={2}><strong>Total Valets</strong></TableCell>
            <TableCell size="small" classes={{ head:classes.header,root:classes.root }} align="center" colSpan={3}><strong>Full Time</strong></TableCell>
            <TableCell size="small" classes={{ head:classes.header,root: `${classes.root} ${classes.borderLeft}` }} align="center" colSpan={3}><strong>On Demand</strong></TableCell>
            <TableCell size="small" classes={{ head:classes.header,root:classes.root }} align="center" rowSpan={2}><strong>Actions</strong></TableCell>
          </TableRow>

          {/* Second Row - Sub Columns */}
          <TableRow>
            {/* Full Time sub-columns */}
            <TableCell classes={{ head:classes.header,root:classes.root }} align="center">Total</TableCell>
            <TableCell classes={{ head:classes.header,root:classes.root }} align="center">Present</TableCell>
            <TableCell classes={{ head:classes.header,root:classes.root  }} align="center">Absent</TableCell>

            {/* On Demand sub-columns */}
            <TableCell classes={{ head:classes.header,root: `${classes.root} ${classes.borderLeft}` }} align="center">Total</TableCell>
            <TableCell classes={{ head:classes.header,root:classes.root }} align="center">Present</TableCell>
            <TableCell classes={{ head:classes.header,root:classes.root }}  align="center">Absent</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {data.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{row.name?.value}</TableCell>
              <TableCell align="center" >{row.total_valets?.value}</TableCell>

              {/* Full Time values */}
              <TableCell align="center">{row.full_time?.value}</TableCell>
              <TableCell align="center">{row.full_time_present?.value}</TableCell>
              <TableCell align="center">{row.full_time_absent?.value}</TableCell>

              {/* On Demand values */}
              <TableCell align="center">{row.on_demand?.value}</TableCell>
              <TableCell align="center">{row.on_demand_present?.value}</TableCell>
              <TableCell align="center">{row.on_demand_absent?.value}</TableCell>

              {/* Action buttons */}
              <TableCell align="center">
                <IconButton size="small" color="primary" onClick={onEdit}>
                  <EditIcon fontSize="small" />
                </IconButton>
                {/* <IconButton size="small" color="secondary">
                  <DeleteIcon fontSize="small" />
                </IconButton> */}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
    </CardBox>
  );
};

export default LocationsTable;
